// extracted by mini-css-extract-plugin
export default {"commented_person_link":"styles_commented_person_link__IpkzO","commented_persons_name":"styles_commented_persons_name__20CTR"};